import { defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { createLoadableId } from "../records";
/** @public */ export const localizationProviderLoadableProps = {
    // We don't have any props b/c it's implicitly based
    // on the application id in the editor
    applicationId: T.integer
};
export const createLocalizationProviderLoadableId = ()=>{
    return createLoadableId("localization_provider", "default");
};
export const isLocalizationProviderLoadable = (loadable)=>{
    if (!loadable) return false;
    if (loadable.typeName !== "loadable") return false;
    return loadable.type === "localization_provider";
};
/** @internal */ export const localizationProviderLoadableMigrations = defineMigrations({});
export const SWLocalizationProviderLoadableInfo = {
    migrations: localizationProviderLoadableMigrations,
    props: localizationProviderLoadableProps,
    meta: {}
};
